import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeModeService } from './core/services/theme-mode.service';
import { CountryComponent } from './views/pages/masters/countries/country/country.component';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { CurrencyComponent } from './views/pages/masters/currencies/currency/currency.component';
import { MsisdnComponent } from './views/pages/masters/MSISDN/msisdn/msisdn.component';






@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,CountryComponent,SimpleNotificationsModule, CurrencyComponent, MsisdnComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'demo1';

  constructor(private themeModeService: ThemeModeService) {}

}
